import $ from 'jquery';
import _ from 'underscore';

/* -------------------------
    INIT
------------------------- */

const template = `
  <div class="c-select">
    <div class="c-select__options js-select__options">
      <input class="c-select__options__input js-select__input"/>
    </div>
    <div class="c-select__icon c-select__icon--open js-select__open">
      <svg width="17px" height="10px" viewBox="0 0 17 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path d="M16.85,1.75 C16.85,2.05 16.75,2.25 16.55,2.45 L9.25,9.55 C8.85,9.95 8.25,9.95 7.85,9.55 L0.55,2.45 C0.15,2.05 0.15,1.45 0.55,1.05 C0.95,0.65 1.55,0.65 1.95,1.05 L8.55,7.55 L15.15,1.05 C15.55,0.65 16.15,0.65 16.55,1.05 C16.75,1.25 16.85,1.55 16.85,1.75 Z"></path>
      </svg>
    </div>
    <div class="c-select__icon c-select__icon--close  js-select__close">
      <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path d="M9.95905243,8.51709971 L16.5157889,2.14 C16.7157889,1.94 16.8157889,1.74 16.8157889,1.44 C16.8157889,1.24 16.7157889,0.939999998 16.5157889,0.739999998 C16.1157889,0.339999998 15.5157889,0.339999998 15.1157889,0.739999998 L8.51578872,7.24 L1.91578857,0.739999998 C1.51578856,0.339999998 0.915788546,0.339999998 0.515788536,0.739999998 C0.115788527,1.14 0.115788527,1.74 0.515788536,2.14 L7.04673648,8.49201771 L0.490000005,14.8691174 C0.29,15.0691174 0.189999998,15.2691174 0.189999998,15.5691174 C0.189999998,15.7691174 0.29,16.0691174 0.490000005,16.2691174 C0.890000014,16.6691174 1.49000003,16.6691174 1.89000004,16.2691174 L8.49000019,9.76911742 L15.0900003,16.2691174 C15.4900003,16.6691174 16.0900004,16.6691174 16.4900004,16.2691174 C16.8900004,15.8691174 16.8900004,15.2691174 16.4900004,14.8691174 L9.95905243,8.51709971 Z"></path>
      </svg>
    </div>
    <div class="c-select__dropdown js-select__dropdown">
    </div>
  </div>
`;

const selectOptionTemplate = (option) => `<option value="${option.value}" selected>${option.text}</value>`;

const optionTemplate = (option) => `
  <div class="c-select__option js-select__option" data-value="${option.value}">
    <span class="c-select__option__text">${option.text}</span>
    <span class="c-select__option__count">${option.count}</span>
    <a class="c-select__option__delete js-select__option__delete">×</a>
  </div>
`;

const dropDownOptionTemplate = (option, val) => `
  <div class="c-select__dropdown__option js-select__dropdown__option" data-value="${option.value}">
    <span class="c-select__dropdown__option__text">${highlight(option.text, val)}</span>
    <span class="c-select__dropdown__option__count">${option.count} produit${option.count > 1 ? 's': ''}</span>
  </div>
`;

function highlight(text, pattern){
  var index = text.toLowerCase().indexOf(pattern);
  if ( index >= 0 ){
    text = text.substring(0,index) + "<span class='c-select__option__text__highlight'>" + text.substring(index,index+pattern.length) + "</span>" + text.substring(index + pattern.length);
  }
  return text;
}

function addOption(option) {
  var self = this;
  self.options.push(option);
  var val = self.$input.val();

  if(self.selected.indexOf(option.value) > -1){
    self.$options.prepend(optionTemplate(option));
    self.$select.append(selectOptionTemplate(option));
  } else {
    self.$dropdown.append(dropDownOptionTemplate(option, val));
  }
}

function updateOption(value, option) {
  var self = this;
  var val = self.$input.val();

  self.options = self.options.map(function(elem) {
    if(elem.value === value){
      return option;
    }
    return elem;
  });

  if(self.selected.indexOf(value) > -1){
    self.$options.find(`[data-value="${value}"]`).replaceWith(optionTemplate(option));
    self.$select.find(`[value="${value}"]`).replaceWith(selectOptionTemplate(option));
  } else {
    self.$dropdown.find(`[data-value="${value}"]`).replaceWith(dropDownOptionTemplate(option, val));
  }
}

function Select(select){
  var self = this;
  self.$select = $(select).hide();
  self.$el = $(template).insertAfter(self.$select);
  self.$options = self.$el.find(".js-select__options").first();
  self.$input = self.$el.find(".js-select__input").first();
  self.$dropdown = self.$el.find(".js-select__dropdown").first();

  self.selected = [];
  self.$select.find("option").each(function(index, option) {
    var $option = $(option);
    if($option.attr("selected")){
      self.selected.push($option.val());
    }
  });
  self.checkIfHasItems();

  self.options = [];

  self.addOption = addOption.bind(self);
  self.updateOption = updateOption.bind(self);


  $(document).on("click", function(){
    self.close();
  })

  self.$el.on("click", function(e){
    self.open();
    e.preventDefault();
    e.stopPropagation();
  });

  self.$el.find(".js-select__close").on("click", function(e){
    self.close();
    e.preventDefault();
    e.stopPropagation();
  });

  self.$el.on("click", ".js-select__option__delete", function(e){
    var $option = $(e.currentTarget).closest('.js-select__option');
    self.selected = self.selected.filter(el => el !== $option.data("value"));
    $.proxy(self.refreshUI, self)();
    self.$select.trigger("change");
    e.preventDefault();
    self.checkIfHasItems();
  });

  self.$el.on("click", ".js-select__dropdown__option", function(e){
    var $option = $(e.currentTarget);
    var value = $option.data("value");
    if(self.selected.indexOf(value) > -1){
      self.selected = self.selected.filter(el => el !== $option.data("value"));
    } else {
      self.selected.push(value);
    }
    $.proxy(self.refreshUI, self)();
    self.$select.trigger("change");
    e.preventDefault();
    self.checkIfHasItems();
  });

  self.$input.on("keyup", function(){
    _.throttle($.proxy(self.refreshUI, self), 100)();
  });
}

Select.prototype.checkIfHasItems = function() {
  var self = this;
  if(self.selected.length){
    self.$el.addClass('has-items');
  } else {
    self.$el.removeClass('has-items');
  }
}

Select.prototype.refreshUI = function(options) {
  var self = this;

  if(options){
    self.options = options;
  }

  var val = self.$input.val();
  var searchedOptions = self.options.filter(el => el.text.toLowerCase().indexOf(val) !== -1);

  self.$options.find(".js-select__option").remove();
  self.$select.empty();
  self.$dropdown.empty();

  $.each(searchedOptions, function(index, option) {
    if(self.selected.indexOf(option.value) > -1){
      self.$options.prepend(optionTemplate(option));
      self.$select.append(selectOptionTemplate(option));
    } else {
      self.$dropdown.append(dropDownOptionTemplate(option, val));
    }
  });
};

Select.prototype.open = function() {
  this.$el.addClass("is-open");
  this.$input.focus();
};

Select.prototype.close = function() {
  this.$el.removeClass("is-open");
};


export default Select;




// WEBPACK FOOTER //
// ./scripts/components/Select.js